import Component from './drop-menu'

export default Component